// SalesShark — German
const de = {
    code: "de",
    label: "Deutsch",
    short: "DE",
    flag: "🇩🇪",
    htmlLang: "de",
    nav: {
        home: "Startseite",
        services: "Leistungen",
        about: "Über uns",
        references: "Referenzen",
        contact: "Kontakt",
        faq: "FAQ",
        consultation: "Kostenlose Beratung",
    },
    hero: {
        eyebrow: "International Sales Agency",
        headingA: "Jede Minute, in der Sie sich nicht für uns entscheiden,",
        headingB: "spielt Ihren Wettbewerbern in die Karten.",
        subheading:
            "Vorhersehbare, messbare Sales-Pipeline von der Zielmarktauswahl bis zum Vertragsabschluss — aufgebaut auf unserer eigenen Unternehmensdatenbank, gezielten E-Mail-Kampagnen und mehrsprachiger Telefonakquise.",
        ctaPrimary: "Kostenlose Beratung",
        ctaSecondary: "Unsere Leistungen",
        marketsLabel: "Aktive Märkte",
        markets: [
            { code: "HU", name: "Ungarn" },
            { code: "SK", name: "Slowakei" },
            { code: "CZ", name: "Tschechien" },
            { code: "AT", name: "Österreich" },
        ],
    },
    quickServices: {
        eyebrow: "Was wir bieten",
        heading: "Neun Bereiche, eine einheitliche Vertriebsmaschine.",
        subheading:
            "Von der Unternehmensdatenbank bis zum Vertragsabschluss — der gesamte Weg mit einem Team.",
        items: [
            "Firmendatenbank nach Ländern",
            "Terminvereinbarung",
            "Kaltakquise",
            "Telemarketing",
            "Personalbereitstellung",
            "Markterschließung",
            "Branding",
            "Marketing",
            "Social Media",
        ],
    },
    results: {
        eyebrow: "SalesShark",
        heading: "Das Ergebnis zählt.",
        bullets: [
            "SalesShark ist ein ergebnisorientiertes Team für Kundengewinnung: Wir bauen eine vorhersehbare, messbare Pipeline von der Zielmarktauswahl bis zum Vertragsabschluss.",
            "Unser stärkster Wert: unsere eigene, nach Ländern strukturierte Firmendatenbank (HU / SK / CZ / AT), auf der wir gezielte E-Mail-Kampagnen und Telefonakquise für qualifizierte Meetings aufbauen und einen dedizierten Sales-Mitarbeiter für den Abschluss stellen.",
            "Sprachen: Ungarisch, Slowakisch, Tschechisch, Englisch, Deutsch.",
            "Wir glauben an die Kraft menschlicher Beziehungen: Vertrauen, ehrliche Kommunikation und konsequente Nachverfolgung sind aus unserer Sicht stärker als jeder „Trick”.",
        ],
        ctaPrimary: "Kostenlose Beratung",
        ctaSecondary: "Kontakt",
    },
    detailedServices: {
        eyebrow: "Unsere Leistungen",
        heading: "Ein klarer Prozess, sieben umsatzstarke Module.",
        subheading:
            "Von der Firmendatenbank bis zum Monatsreport — jedes Modul ist Teil einer einheitlichen Vertriebsmaschine.",
        ctaMore: "Mehr erfahren",
        items: [
            { title: "Firmendatenbank HU / SK / CZ / AT", text: "Firmenlisten mit Filtern und Kontaktdaten." },
            { title: "E-Mail-Marketing", text: "Massen-E-Mail-Versand + Termin-Booking-CTA + Reporting." },
            { title: "Telefonakquise", text: "Kaltakquise, Telemarketing in HU / SK / CZ / EN / DE." },
            { title: "Personalbereitstellung", text: "Kurz- und langfristige Vertriebsressourcen nach Bedarf in HU / SK / CZ / EN / DE mit unserem System + Bestandskundenbetreuung." },
            { title: "Marketing + PPC", text: "Branding, Videos, Kreative, Corporate Identity, Werbematerialien, Visitenkarten, Social-Media-Kampagnenplanung und -umsetzung." },
            { title: "Expansionsunterstützung (HU / SK / CZ / AT)", text: "Marktforschung, Firmengründung, Bankkonto, weitere administrative Hilfe." },
            { title: "Monatlicher Report", text: "Status, KPIs, nächste Schritte, regelmäßige Zusammenfassung." },
        ],
    },
    problems: {
        eyebrow: "Was trifft auf Sie zu?",
        heading: "Erzählen Sie es uns!",
        subheading:
            "Wenn Ihnen auch nur eine der folgenden Situationen bekannt vorkommt, können wir wahrscheinlich zusammenarbeiten.",
        cta: "Kostenlose Beratung",
        items: [
            "Mein Produkt/Service ist gut, aber ich möchte mehr Kunden.",
            "Ich möchte in ein anderes Land expandieren.",
            "Ich brauche einen professionellen Marketer.",
            "Ich habe keinen Überblick über die Arbeit meines Vertrieblers: Wie viele Firmen haben wir angerufen?",
            "Ich brauche einen neuen Mitarbeiter.",
            "Ich möchte Entscheider erreichen, keine allgemeinen Kontakte.",
            "Mir fehlt die Zeit, täglich Interessenten zu suchen und anzurufen.",
            "Ich will Lösungen, kein Drumherumgerede.",
            "Ich kümmere mich zu wenig um meine Bestandskunden.",
        ],
    },
    references: {
        eyebrow: "Referenzen",
        headingA: "Die Erfolge unserer Partner",
        headingB: "sind unsere wichtigste Referenz.",
        statBadge: "50+ Partner · 4 Märkte · 5 Sprachen",
        verifiedBadge: "Verifiziert",
        items: [
            { company: "WHC SLOVAKIA", role: "CEO", text: "Wir schätzen die Einstellung, Genauigkeit und den Fokus des Teams auf echte Geschäftsergebnisse besonders. SalesShark ist ein Partner, dem ein wachstumsorientiertes Unternehmen bedenkenlos einen Teil oder den gesamten Vertriebsprozess anvertrauen kann." },
            { company: "iNTRETECH", role: "CEO", text: "In der Zusammenarbeit mit Antal und Antónia haben wir einen Partner gefunden, der echten Mehrwert in unseren Vertriebsprozessen schafft. Die Qualität der Ansprache, die Transparenz des Reportings und die fachliche Kompetenz des Teams haben uns bestätigt, dass datengetriebener Vertrieb heute unerlässlich ist." },
            { company: "MOTIM ZRT.", role: "CEO", text: "Mit dem SalesShark-Team wurde schnell klar, dass wir keinen einfachen Dienstleister gewählt haben, sondern einen echten strategischen Partner. Ihr System ist transparent, ihre Kommunikation professionell und jede Aktivität messbar. SalesShark liefert konkrete, nachvollziehbare Ergebnisse — deshalb arbeiten wir mit ihnen." },
        ],
    },
    goal: {
        eyebrow: "Unser Ziel",
        heading: "Ergebnisse liefern — von besserer Kundenbetreuung bis zu neuen Märkten.",
        p1: "Ergebnisse liefern, von besserer Kundenbetreuung über Vertriebssteigerung bis hin zur Erschließung völlig neuer Märkte.",
        p2: "Mit uns gewinnen Sie einen verlässlichen Partner, der Ihr Unternehmen Schritt für Schritt unterstützt.",
        ctaContact: "Kontakt",
        ctaPresentation: "Unternehmenspräsentation",
    },
    about: {
        eyebrow: "Über uns",
        headingA: "Wir arbeiten mit Daten,",
        headingB: "messen in Ergebnissen,",
        headingC: "glauben an menschliche Beziehungen.",
        story: {
            eyebrow: "Unsere Geschichte",
            p1: "2023 gründeten wir in Bratislava die internationale Personalagentur GLOBEFOX — hier begann der internationale Sales-Fokus, der heute die Grundlage von SalesShark bildet.",
            p2: "Heute rekrutieren wir in Ungarn, der Slowakei und Tschechien und arbeiten mit über 50 Partnern zusammen, darunter Produktionsgiganten und Marktführer. Neben der Personalvermittlung unterstützen wir unsere Kunden auch bei Firmengründungen und Buchhaltung.",
            p3: "Unsere internationale Erfahrung und unser mehrsprachiges Team ermöglichen es, unsere Kunden grenzüberschreitend auf professionellem Niveau zu vertreten.",
        },
        stats: [
            { n: "2023", label: "Gegründet in Bratislava" },
            { n: "50+", label: "Aktive Partner" },
            { n: "4", label: "Märkte · HU / SK / CZ / AT" },
            { n: "5", label: "Sprachen · HU / SK / CZ / EN / DE" },
        ],
        pillars: {
            eyebrow: "Warum wir",
            headingA: "Vier Prinzipien, ein roter Faden:",
            headingB: "Ergebnis.",
            items: [
                { title: "Datengetriebener Vertrieb", text: "Wir bauen messbare Pipeline aus unserer eigenen, nach Ländern strukturierten Firmendatenbank — keine Vermutungen." },
                { title: "Messbare Ergebnisse", text: "Wöchentlicher Status, KPIs, Reports — Sie wissen jederzeit, wo der Prozess steht und was der nächste Schritt ist." },
                { title: "Menschliche Beziehungen", text: "Vertrauen, ehrliche Kommunikation und konsequente Nachverfolgung sind stärker als jeder Trick." },
                { title: "Mehrsprachiger Betrieb", text: "Wir vertreten unsere Kunden auf Ungarisch, Slowakisch, Tschechisch, Englisch und Deutsch — grenzüberschreitend." },
            ],
        },
        team: {
            eyebrow: "Das Team",
            heading: "Die Gesichter hinter dem Prozess.",
            members: [
                {
                    role: "Geschäftsführerin / CEO · Internationale Juristin",
                    bio: [
                        "2023 gründeten wir in Bratislava die internationale Personalagentur GLOBEFOX. Ich stieg als internationale Juristin ein und spreche vier Sprachen.",
                        "Das ermöglichte GLOBEFOX von Anfang an eine internationale Ausrichtung — heute rekrutieren wir in Ungarn, der Slowakei und Tschechien. Wir arbeiten mittlerweile mit über 50 Partnern zusammen, darunter Produktionsgiganten und Marktführer.",
                        "Unsere internationale Erfahrung und unser mehrsprachiges Team ermöglichen es, unsere Kunden grenzüberschreitend auf professionellem Niveau zu vertreten.",
                    ],
                },
                {
                    role: "COO / Operativer Leiter · Gründer",
                    bio: [
                        "Ich verantworte Strategie und den Aufbau der Vertriebssysteme: Mein Ziel ist, dass jeder unserer Kunden eine Sales-Lösung erhält, die echtes Wachstum und stabile Kundengewinnung bringt.",
                        "Täglich beschäftige ich mich mit Kampagnenplanung, datengetriebener Optimierung und den Prozessen, die unseren Kunden mehr Interessenten, Termine und neue Kunden sichern.",
                        "Unser Ziel ist, dass SalesShark die stärkste und zuverlässigste Sales-Agentur der Region wird — mit echten Ergebnissen, nicht mit Versprechen.",
                    ],
                },
            ],
        },
    },
    contact: {
        eyebrow: "Kontakt",
        headingA: "Haben Sie eine Frage?",
        headingB: "Wir antworten innerhalb von 24 Stunden.",
        ctaConsultation: "Kostenlose Beratung",
        officeTitle: "Unsere Büros",
        officeSubtitle: "Vier Büros in der Region",
        offices: [
            { country: "HU", city: "2900 Komárom" },
            { country: "SK", city: "811 01 Bratislava" },
            { country: "HU", city: "9200 Mosonmagyaróvár" },
            { country: "SK", city: "943 01 Dunaszerdahely" },
        ],
        company: {
            name: "GLOBEFOX s.r.o.",
            addressLine1: "Sabinovska 9., Bratislava",
            addressLine2: "831 04, Slowakei",
            id: "Firmennr.: 55 100 376",
        },
    },
    form: {
        eyebrow: "Schreiben Sie uns",
        heading: "Hinterlassen Sie eine Nachricht — Antwort innerhalb von 24 Stunden.",
        labels: {
            name: "Name",
            email: "E-Mail",
            phone: "Telefon",
            company: "Firma",
            message: "Nachricht",
        },
        placeholders: {
            name: "Max Mustermann",
            email: "max@firma.de",
            phone: "+49 30 12345678",
            company: "Acme GmbH",
            message: "Wie können wir helfen?",
        },
        companyHelper: "Optional — als Privatperson leer lassen.",
        disclaimer:
            "Mit dem Absenden stimmen Sie zu, dass wir Sie unter den angegebenen Kontaktdaten erreichen dürfen.",
        submit: "Nachricht senden",
        sending: "Senden…",
        successTitle: "Ihre Nachricht ist angekommen.",
        successText: "Wir antworten innerhalb von 24 Stunden an die angegebene E-Mail-Adresse.",
        errorTitle: "Leider konnte nicht gesendet werden.",
        errorText: "Bitte erneut versuchen oder direkt an uns schreiben.",
    },
    faq: {
        eyebrow: "FAQ",
        headingA: "Häufig gestellte Fragen.",
        headingB: "Kurze, klare Antworten.",
        items: [
            { q: "In welchen Ländern sind Sie tätig?", a: "Wir sind in Ungarn, der Slowakei, Tschechien und Österreich aktiv. Mit unserer eigenen, nach Ländern strukturierten Firmendatenbank und unserem mehrsprachigen Team (Ungarisch, Slowakisch, Tschechisch, Englisch, Deutsch) unterstützen wir unsere Partner beim Markteintritt und Wachstum." },
            { q: "Wie groß ist Ihre Firmendatenbank?", a: "Ungarn: 16.000 Firmen, Slowakei: 13.000 Firmen, Österreich: 47.000 Firmen, Tschechien: 3.000 Firmen. Die Datenbank wird laufend aktualisiert und lässt sich nach Branche, Firmengröße, Standort und Region filtern." },
            { q: "In welchen Sprachen erfolgt die Telefonakquise?", a: "Anrufe und Follow-up führen wir auf Ungarisch, Slowakisch, Tschechisch, Englisch und Deutsch durch." },
            { q: "Werden die E-Mail-Kampagnen in Ihrem Namen versendet?", a: "Nein. Die E-Mail-Sequenzen werden von Ihrer eigenen Firmen-E-Mail-Adresse gesendet, damit Sie Zustellungen, Antworten und den Fortschritt der Termine direkt verfolgen können." },
            { q: "Was enthält der Monatsreport?", a: "Status, KPIs, nächste Schritte und eine regelmäßige Zusammenfassung — damit Sie immer wissen, wo die Pipeline steht." },
            { q: "Wie können wir die Zusammenarbeit starten?", a: "Buchen Sie eine 15-minütige kostenlose Beratung im Kalender. Wir kartieren den Zielmarkt, Ihre aktuelle Situation und empfehlen die beste Markteintrittsstrategie." },
        ],
        notFoundEyebrow: "Antwort nicht gefunden?",
        notFoundHeading: "Fragen Sie uns direkt.",
        ctaConsultation: "Kostenlose Beratung",
        ctaContact: "Kontakt",
    },
    footer: {
        eyebrow: "Starten Sie heute",
        heading: "Sprechen wir über Ihren nächsten Markt.",
        subheading:
            "15-minütige kostenlose Beratung — messbare Sales-Pipeline in den Märkten HU / SK / CZ / AT.",
        cta: "Kostenlose Beratung",
        tagline:
            "International Sales Agency. Ergebnisorientierte Kundengewinnung, eigene Firmendatenbank und dedizierter Sales-Mitarbeiter für die Märkte HU / SK / CZ / AT.",
        contactHeading: "Kontakt",
        menuHeading: "Menü",
        copyright: (year) =>
            `© ${year} SalesShark · GLOBEFOX s.r.o. Alle Rechte vorbehalten.`,
        roles: {
            antonia: "Antónia Somogyi · CEO",
            antal: "Antal Korcz · COO",
        },
    },
    services: {
        hero: {
            eyebrow: "Unsere Leistungen",
            headingA: "Digitaler und menschlicher Vertrieb im Einklang —",
            headingB: "auf Ergebnis optimiert.",
            subheading:
                "Sechs Module, ein einheitlicher Prozess — von der Marktforschung bis zur persönlichen Vertretung.",
        },
        sideNavTitle: "Leistungen",
        eyebrows: {
            dataDriven: "Datengetriebener Vertrieb",
            process: "Prozess",
            service: "Leistung",
        },
        ctaConsultation: "Kostenlose Beratung",
        ctaContact: "Kontakt",
        bottomCta: {
            eyebrow: "Bereit für den nächsten Schritt?",
            heading: "Ein 15-minütiges Gespräch über Ihren nächsten Markt.",
            subheading:
                "Wir zeigen Ihnen, wie wir mit unserer eigenen Datenbank messbare Pipeline in den Märkten HU / SK / CZ / AT aufbauen.",
        },
        sections: {
            cegadatbazis: {
                label: "Firmendatenbank",
                title: "Firmendatenbank",
                intro: [
                    "Die Datenbank enthält auch Kurzinformationen zu Firmen und Website-Kontakte.",
                    "Wenn Sie bisher potenzielle Zielpartner über Google gesucht haben, beschleunigt sich damit Marktforschung und Ansprache deutlich.",
                    "Unsere Datenbank mit namentlichen Kontakten wird laufend aktualisiert.",
                ],
                statLabel: "Firmen",
                stats: [
                    { country: "Ungarn", value: "16.000" },
                    { country: "Slowakei", value: "13.000" },
                    { country: "Österreich", value: "47.000" },
                    { country: "Tschechien", value: "3.000" },
                ],
                filtersTitle: "Folgende Filter stehen zur Verfügung:",
                filters: ["Branche", "Firmengröße (Mitarbeiterzahl)", "Standort", "Region"],
            },
            email: {
                label: "E-Mail-Marketing",
                title: "E-Mail-Marketing",
                steps: [
                    { title: "Auswahl der Zielgruppe aus der Firmendatenbank", text: "Filterung nach Branche, Region, Firmengröße." },
                    { title: "Massen-E-Mail-Sequenzen", text: "Newsletter, Vorstellungs- und Angebots-E-Mails mit geplantem Follow-up und Abmeldemöglichkeit." },
                    { title: "Integrierte Terminbuchung (CTA)", text: "Der Empfänger bucht mit einem Klick einen 15-minütigen Termin; das System trägt ihn automatisch in den Kalender ein." },
                    { title: "Tracking und Reporting in Echtzeit", text: "Zustellung, Öffnung, Klick, Antwort, Buchung — messbar pro Kampagne und pro Empfänger." },
                    { title: "Von Ihrer eigenen Firmen-E-Mail-Adresse", text: "Die E-Mail-Sequenzen werden von Ihrer Firmen-E-Mail-Adresse gesendet, sodass Sie Zustellungen, Antworten und den Fortschritt der Termine direkt verfolgen können." },
                ],
            },
            phone: {
                label: "Telefonakquise",
                title: "Telefonakquise",
                items: [
                    { title: "Kaltakquise", text: "Wir kontaktieren Firmen aus der Datenbank mit einem strukturierten Gesprächsleitfaden." },
                    { title: "„Warme” Anrufe", text: "Wir rufen auch Empfänger an, die in der E-Mail-Kampagne aktiv waren." },
                    { title: "Terminvereinbarung", text: "Unser Ziel ist es, den Entscheider zu erreichen und einen Termin für Ihren Vertriebler zu buchen." },
                    { title: "Telemarketing", text: "Einarbeitung und Telefonverkauf + Report." },
                    { title: "Mehrsprachige Ansprache", text: "Anrufe und Follow-up führen wir auch auf Ungarisch, Slowakisch, Tschechisch, Englisch und Deutsch durch." },
                    { title: "Übergabe und Dokumentation", text: "Wer, worüber, was ist der Bedarf, nächster Schritt, vereinbarter Termin oder Absage." },
                ],
            },
            staff: {
                label: "Personalbereitstellung",
                title: "Personalbereitstellung",
                items: [
                    { title: "Vertriebs-, Telesales-, Sachbearbeiter- oder Koordinator-Personal", text: "Aus Lebensläufen wählbare gelegentliche oder langfristige Partner, die das „Gesicht” Ihrer Firma sind und in HU / SK / CZ / EN / DE in Ihrem Namen kommunizieren." },
                    { title: "System", text: "Der Mitarbeiter nutzt unseren Workflow (Status, Follow-up, Meeting Brief, Reports)." },
                    { title: "Vollständige Ausrüstung auf Wunsch", text: "Firmenwagen, Telefon und Laptop, damit die Arbeit sofort auf professionellem Niveau starten kann." },
                    { title: "Onboarding und Einarbeitung", text: "Vorbereitung auf Produkt und Zielmarkt." },
                    { title: "Fachliche Aufsicht", text: "Führung und Qualitätskontrolle, wöchentlicher Status/Report + Pipeline, damit wir immer wissen, wo wir stehen." },
                ],
            },
            marketing: {
                label: "Marketing",
                title: "Marketing",
                items: [
                    { title: "Branding", text: "Corporate-Identity- und Logo-Design." },
                    { title: "Kreativ-Produktion", text: "Professionelle Fotos, Videos, Grafik-Assets, Animationen — auch in mehreren Sprachen." },
                    { title: "Sales-Unterlagen", text: "Präsentationen, Angebote, One-Pager, Visitenkarten, Werbematerial." },
                    { title: "Online-Werbung (PPC)", text: "Kampagnenplanung, Setup und laufende Optimierung (FB/IG/Google)." },
                    { title: "Social-Media-Content und Kampagnen", text: "Posts, Anzeigen." },
                    { title: "Messung und Reporting", text: "KPI-Tracking, Learnings, Feintuning und Skalierung." },
                ],
            },
            expansion: {
                label: "Expansion",
                title: "Sie expandieren? Wir helfen!",
                steps: [
                    { title: "Marktforschung und Zielmarkt-Definition", text: "Länderfokus (Branche, Firmengröße, Region, Wettbewerb)." },
                    { title: "Eintrittsstrategie und Zeitplan", text: "An wen wir verkaufen, mit welchem Angebot, über welche Kanäle, in welchen Schritten." },
                    { title: "Gezielte Firmenliste und Entscheider-Kontakte", text: "Im jeweiligen Land, auf Basis unserer eigenen Datenbank (HU / SK / CZ / AT)." },
                    { title: "Markteintritts-Outreach-Kampagnen", text: "Segmentierte Vorstellungs-E-Mails + mehrstufiges Follow-up." },
                    { title: "Mehrsprachige Telefonakquise und Terminvereinbarung", text: "In HU / SK / CZ / EN / DE, mit qualifizierten Meetings." },
                    { title: "Persönliche Vertretung", text: "Sowohl gelegentliche als auch langfristige Projekte." },
                    { title: "Reporting und Optimierung", text: "Ergebnismessung, Feintuning, Skalierung auf die leistungsstärksten Segmente." },
                    { title: "Optional: Firmengründung, Übersetzung, Kontoeröffnung, weitere Verwaltung", text: "Praktische Unterstützung für Start und Betrieb." },
                ],
            },
        },
    },
    languageSwitcher: {
        label: "Sprache",
        aria: "Sprache wählen",
    },
};

export default de;
